import './index.scss';
import '@/component/page';
import ajax from '@/util/ajax';

import '@/component/inputline';
import '@/component/radio';
import security from '@/component/security';

/** 接口url */
const getEnvironmentInfo = '/vehicle-api/v1-0/vehicles/environmental'; // 查询环保信息
const getEnvironmentInfoNew =
    '/mall-unit-api/v1-0/vehicles/environmental-infos'; // 查询环保信息-new

const reg = {
    vin: /^[a-zA-Z0-9]{17}$/
};

export default {
    data() {
        return {
            inputValue: '',
            inputFocus: false,
            verificationCode: '',
            errorMessage: '',

            disabled: false,
            status: 0, // 1=搜索中，2=无结果，3=有结果

            showResult: 0,
            resultTitle: '',
            resultUrl: '',
            searchResult: [],

            tabIndex: 0
        };
    },
    mounted() {
        const input = document.getElementsByTagName('input');
        if (input && input.length) {
            input[0].addEventListener('focus', () => {
                this.inputFocus = true;
            });
            input[0].addEventListener('blur', () => {
                this.inputFocus = false;
            });
        }
    },
    methods: {
        switchTab(index) {
            if (this.tabIndex !== index) {
                this.tabIndex = index;
                this.inputValue = '';
                this.errorMessage = '';
            }
        },
        // 动态验证码
        securityShow() {
            security.show(this.securitySuccess);
        },
        securitySuccess(token) {
            this.disabled = true;
            if (this.tabIndex === 0) {
                this.searchOther(token);
            } else {
                this.searchVin(token);
            }
        },
        submit() {
            if (this.tabIndex === 0) {
                if (this.inputValue.length < 5) {
                    this.errorMessage =
                        '请输入正确的环保信息公开编号 / 车型型号 / 发动机型号';
                } else {
                    this.securityShow();
                }
            } else if (this.inputValue.length < 17) {
                this.errorMessage = '车辆VIN码不满17位';
            } else if (!reg.vin.test(this.inputValue)) {
                this.errorMessage = '车辆VIN码填写错误';
            } else {
                this.securityShow();
            }
        },
        async searchOther(token) {
            this.showResult = 0;
            this.status = 1;
            const { response } = await ajax.get(getEnvironmentInfoNew, {
                offset: 0,
                limit: 999,
                queryStr: this.inputValue,
                token
            });
            console.log(response);
            if (response.data && response.data.length) {
                this.errorMessage = '';
                this.searchResult = response.data;
                this.status = 3;
                this.disabled = false;
            } else if (response.errors) {
                this.errorMessage = response.errors[0].message;
                this.status = 2;
                this.disabled = false;
            } else {
                this.errorMessage = '';
                this.status = 2;
                this.disabled = false;
            }
        },
        async searchVin(token) {
            this.showResult = 1;
            this.status = 1;
            try {
                const { response } = await ajax.get(getEnvironmentInfo, {
                    vin: this.inputValue,
                    token
                });
                if (response.data && response.data.pdfUrl) {
                    this.resultTitle = `理想ONE | ${this.inputValue}`;
                    this.resultUrl = response.data.pdfUrl;
                    this.status = 3;
                    this.disabled = false;
                } else {
                    this.status = 2;
                    this.disabled = false;
                }
            } catch ({ response, status }) {
                this.status = 2;
                this.disabled = false;
            }
            this.errorMessage = '';
        },
        openPdf(url) {
            window.open(url);
        }
    }
};
